import React from 'react';
import './Hero.css';

const Hero = ({ scrollToSection }) => {
  const handleGetInTouch = () => {
    scrollToSection('contact');
  };

  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title animate-fade-in-up">
            Totalguard Workwear Rosslyn: Built for Safety. Designed for Performance.
          </h1>
          <p className="hero-subtitle animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            At Totalguard Workwear Rosslyn, we specialize in providing high-quality PPE clothes, PPE shoes, technical wear, 
            and protective wear for industries and individuals seeking top-notch safety solutions. Our products 
            are designed to meet the highest standards of protection and comfort, ensuring you stay safe and 
            focused on what matters most.
          </p>
          <div className="hero-cta animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
            <button className="btn" onClick={handleGetInTouch}>
              Get in Touch
            </button>
            <button className="btn btn-secondary" onClick={() => scrollToSection('products')}>
              Our Products
            </button>
          </div>
        </div>
      </div>
      
      {/* Floating shapes */}
      <div className="hero-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>
    </section>
  );
};

export default Hero;
